
import React, {useEffect, useState} from 'react';
import {Biscuit, getAllUrlParams, Notification} from "../../../../utils";
import t from '../../../helpers/t';
import OrdersSidebar from '../components/OrdersSidebar';
import {locationActions, ordersActions, reservationsActions, resourcesActions, useSelector} from 'inbooma-api';
import OrdersList from './OrdersList';
import InboomaSubmenu from '../../../components/InboomaSubmenu';
import SortNav from '../../../components/SortNav';
import moment from "moment";
import {getContentModifications} from "../../../../App";
import NextPageBtn from "../../../components/NextPageBtn";
import Loader from "../../../components/Loader";
import {isViewVisible} from "../../../../utils/ViewSettings";
import ChangeLogDialog from "../../../components/ChangeLogDialog";
//import Paginator from "../../../components/Paginator";
import {$, _} from "../../../../../vendor";
import Paginator from "../../../components/paginator";



const OrdersView = (props) => {
    const currentUrl = new URL(window.location.href)
    const searchParams = currentUrl.searchParams;
    const allUrlParams = getAllUrlParams(window.location.href);
    const allUrlParamsClone = {...allUrlParams};
    allUrlParams?.fullname !== null && delete allUrlParams.fullname;
    allUrlParams?.type !== null && delete allUrlParams.type;
    allUrlParams?.order_nbr !== undefined && delete allUrlParams.order_nbr;
    let language = Biscuit.get('user.lang').replace('-','_');
    const [initialized,setInitialized] = useState(false);
    const [filter,setFilter] = useState({
        find: 'full',
        sort: "order_nbr",
        direction: "desc",
        ...allUrlParams
    });
    const [sort,setSort] = useState({
        sort: "order_nbr",
        direction: "desc"
    });
    const [checkout,setCheckout] = useState(false);
    const paginationLimit = 40;
    const [pagination,setPagination] = useState({
        has_next_page: false,
        current_page: 1
    });
    const [orders,setOrders] = useState([]);
    const [orderEmpty,setOrderEmpty] = useState(false);
    const [orderSuccess,setOrderSuccess] = useState(false);
    const [ordersPending,setOrdersPending] = useState(false);
    const _orderSummary = useSelector(state => state.orders.getOrderSummary);
    const [summaryPending, setSummaryPending] = useState(false);
    const [summary,setSummary] = useState([]);
    const [locations,setLocations] = useState([]);
    const [locationsPending,setLocationsPending] = useState(false);
    const _orders = useSelector(state => state["orders"].orders);
    const _locations = useSelector(state => state["locations_data"].locations);
    const [resetFilter,setResetFilter] = useState(false);
    const [_key,setKey] = useState(null);
    const _queryState = {
        timeStamp: 0,
        value: ""
    }
    const [changelogOpen, setChangelogOpen] = useState(false);
    const [changelog, setChangelog] = useState([]);

    useEffect(() => {
        if(locationsPending || initialized || ordersPending) return;
        let initFilter = {...filter};
        if(typeof props.params[1] !== 'undefined' && props.params[0] === "user_id"){
            initFilter ={...filter,user_id:props.params[1]};
        }
        if(typeof props.params[1] !== 'undefined' && props.params[0] === "paystate"){
            initFilter ={...filter,paystate:props.params[1]};
        }
        if(typeof props.params[1] !== 'undefined' && props.params[0] === "id"){
            initFilter ={...filter,id:props.params[1]};
        }
        if(allUrlParamsClone?.order_nbr !== undefined){
            initFilter ={...filter,order_nbr:allUrlParamsClone?.order_nbr};
        }
        props.dispatch(locationActions.getLocations({
            token: Biscuit.get('token'),
            filter: {
                limit: 10000
            },
        }));

        setLocationsPending(true);
        props.dispatch(ordersActions.getOrderResetData());
        setOrders([]);
        console.log(initFilter,'initFilter')
        props.dispatch(ordersActions.getOrders({
            token: Biscuit.get('token'),
            suffix: "",
            filter: initFilter,
            parameters: {
                headers: {
                    'Accept-Language': language,
                    'Content-Language': language
                }
            }
        }));
        setOrdersPending(true);
    },[]);

    useEffect(() => {

        if (_locations.success === "") return;

        if (_locations.success === true && _locations.data.length) {
            let ld = [];
            _locations.data.map(l => {
                ld[l.id] = l;
            })
            setLocations(ld);
        } else if (_locations.success === false) {
            console.log("Failed to request locations!");
        }
        setLocationsPending(false);
        if(!ordersPending) {
            setInitialized(true);
        }
    },[_locations]);

    useEffect(() => {
        if (summaryPending === false || _orderSummary.success === "") {
            return;
        }
        if (_orderSummary.success === true) {
            setSummary(_orderSummary.data);
        } else {
            console.log("Failed fetching order summary!");
        }
        setSummaryPending(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[_orderSummary]);

    useEffect(() => {
        if (_orders.success === "" || !ordersPending || _orders.actionState === 'GET_ORDERS') {
            return;
        }
        let dataLength = typeof _orders.data.length === 'undefined' ? 0 : _orders.data.length;

        if (_orders.success === true) {
            setOrderSuccess(true);
            if(dataLength < 1){
                setOrderEmpty(true);
            }
            setOrders(_orders.data);
            setPagination({..._orders.pagination});
        }
        setOrdersPending(false);
        if(!locationsPending){
            setInitialized(true);
        }
    },[_orders]);

    /*  useEffect(() => {
          if (orders === [] && !ordersPending && !orderEmpty && orderSuccess) {
              return;
          }
          if(orderEmpty){
              setInitialized(true);
          }
          if(ordersPending){
              return;
          }
          setInitialized(true);
      },[orders]);*/

    useEffect(() => {
        if(ordersPending || summaryPending) return;
        props.dispatch(ordersActions.getOrderSummary({
            token: Biscuit.get('token'),
            filter: filter,
            parameters: {
                headers: {
                    'Accept-Language': language,
                    'Content-Language': language
                }
            }
        }));
        setSummaryPending(true);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[orders]);
    const filterChangedHandle = (newFilter) => {

        let requestFilter = {...newFilter};
        requestFilter = {...requestFilter,page: 1};
        requestFilter = {...requestFilter,limit: paginationLimit};
        requestFilter = {...requestFilter,sort: sort.sort};
        requestFilter = {...requestFilter,direction: sort.direction};
        props.dispatch(ordersActions.getOrdersResetData());
        setOrders([]);
        props.dispatch(ordersActions.getOrders({
            token: Biscuit.get('token'),
            suffix: "",
            filter: requestFilter,
            parameters: {
                headers: {
                    'Accept-Language': language,
                    'Content-Language': language
                }
            }
        }));
        setOrdersPending(true);
        setFilter(requestFilter);
    };

    const onSortChangedHandle = (ev) => {

        const el = ev.currentTarget;
        const sortKey = el.getAttribute('data-inb-val'),
            direction = el.getAttribute('data-inb-direction'),
            isOppositeElement = (direction === null && el.classList.contains('is-active')),
            newDirection = (direction === 'desc' || isOppositeElement ? 'asc' : 'desc');

        if (sortKey) {
            let requestFilter;
            if(typeof filter.limit !== 'undefined') {
                requestFilter = {
                    ...filter,
                    sort: sortKey,
                    direction: direction
                };
            } else {
                requestFilter = {
                    ...filter,
                    sort: sortKey,
                    direction: direction,
                    limit: paginationLimit,
                    page: 1
                };
            }

            if(typeof allUrlParams.initial !== 'undefined' && typeof requestFilter.begin_gte === 'undefined'){
                requestFilter.begin_gte = moment().format('YYYY-MM-DD 00:00:00');
                requestFilter.sort = 'begin';
                requestFilter.direction = 'asc';
            }
            setOrders([]);
            props.dispatch(ordersActions.getOrdersResetData());
            props.dispatch(ordersActions.getOrders({
                token: Biscuit.get('token'),
                suffix: "",
                filter: requestFilter,
                parameters: {
                    headers: {
                        'Accept-Language': language,
                        'Content-Language': language
                    }
                }
            }));
            setOrdersPending(true);
            setSort({
                sort: sortKey,
                direction: direction
            });

            const activeSortTab = $('.is-active');
            _.each(activeSortTab, function(key){
                key["classList"].remove('is-active');
            });
            el.classList.add('is-active');
            el.setAttribute('data-inb-direction', (isOppositeElement ? 'desc' : newDirection));
        }
    };

    const loadNextPage = (page) => {

        //  if (!pagination.has_next_page) return;

        setOrdersPending(true);

        let requestFilter = {...filter};
        requestFilter.sort = sort.sort;
        requestFilter.direction = sort.direction;
        requestFilter.limit = paginationLimit;
        requestFilter.page = page;
        // fetch next page
        props.dispatch(ordersActions.getOrders({
            token: Biscuit.get('token'),
            suffix: "",
            filter: requestFilter,
            parameters: {
                headers: {
                    'Accept-Language': language,
                    'Content-Language': language
                }
            }
        }));
    };

    const openChangeLog = (ev) => {
        setChangelog(ev);
        setChangelogOpen(true);
    };
    const handleCloseDialog = () => {
        setChangelogOpen(false);
    }

    const _exchangeLabel = (value) => {

        let cm = getContentModifications();
        if (cm.labels != null) {
            if (cm.labels[value] !== undefined) {
                return cm.labels[value];
            }
        }
        return value;
    };
    const searchBarHandler = (ev) => {
        let query;
        if(typeof ev.target !== 'undefined') {
            query = ev.target.value.toLowerCase();
        } else {
            query = '';
        }
        searchParams.delete('order_nbr');
        searchParams.delete('item');
        if(query !== '') {
            if(isNaN(Number(query))){
                showNotification('warning',null,t('query must be number'));
                query='';
                return;
            }
            searchParams.set('order_nbr', query);
        }
        const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
        history.pushState(null, "", newRelativePathQuery);
        let standardFilter = {
            sort: "order_nbr",
            direction: "desc",
            page: 1,
            find: "full",
            limit: 40,
            ...allUrlParams
        };
        const minLength = 1;
        let filterA = standardFilter;
        if (query.length >= minLength) {                                    // work user search only for values bigger or equal to the minimum length

            setTimeout(function () {

                let diff = Number(moment().format('x')) - _queryState.timeStamp;

                if (diff > 700 && _queryState.value === query) {                  // no changes after the last 700 ms -> user finished input -> start request
                    filterChangedHandle({
                        ...filterA,
                        'order_nbr': query
                    });

                }
            },800);
        } else if (filter.order_nbr !== undefined) {
            // reset filter when query was active
            let clone = {...filter};
            delete clone.order_nbr;
            filterChangedHandle(clone);
        } else {
            filterChangedHandle(filterA);
        }

        _queryState.timeStamp = Number(moment().format('x'));
        _queryState.value = query;
    };
    const showNotification = (msgType, itemId, errorMsg ='',type='order') => {

        if (msgType === 'success') {
            new Notification({
                message : t('saved_${a}',{a:t(type)},'capital')+' #'+ itemId,
                duration : 5000,
                type : 'success',
                closeable : true,
                icon : 'fi fi-check'
            });
        } else if (msgType === 'warning') {
            new Notification({
                message : errorMsg,
                duration : 5000,
                type : 'warning',
                closeable : true,
                icon : 'fi fi-x'
            });
        }
    };
    let sendParams = '';

    if(typeof allUrlParamsClone.order_nbr !== 'undefined'){
        sendParams = '&order_nbr='+allUrlParamsClone.order_nbr;
    }else {
        if(typeof allUrlParamsClone.user_id !== 'undefined'){
            sendParams = '&user_id='+allUrlParamsClone.user_id+'&fullname='+allUrlParamsClone.fullname;
        }
        if(typeof allUrlParamsClone.paystate !== 'undefined'){
            sendParams += '&paystate='+allUrlParamsClone.paystate+'&paystate_name='+allUrlParamsClone.paystate_name;
        }
    }
    if(sendParams === ''){
        sendParams='&initial=true';
    }
    const submenuItems = [
        {
            name: t('reservations',null,'capital'),
            link: 'reservations/reservationsList?type=bookings'+sendParams,
            data_inb_val: t('reservations',null,'capital'),
            icon: 'fi fi-list-thumbnails',
            isActive: false,
            isAccessible: isViewVisible('reservationsList','reservations')
        },{
            name: t('orders',null,'capital'),
            link: 'reservations/orders?type=orders',
            data_inb_val: t('orders',null,'capital'),
            icon: 'fi fi-list',
            isActive: true,
            isAccessible: isViewVisible('orders','reservations')
        },{
            name: t('calendar',null,'capital'),
            link: 'reservations/calendar',
            data_inb_val: t('calendar',null,'capital'),
            icon: 'fi fi-calendar',
            isActive: false,
            isAccessible: isViewVisible('calendar','reservations')
        }
    ];

    let tabs =[{
        name: t('date',null,'capital'),
        smallWidth: 8,
        mediumWidth: 8,
        extraClasses: 'large-2',
        title: t('sort_by_${a}',{a:t('date')},'capital'),
        canSort: false,
    },{
        name: t('order_nbr',null,'capital'),
        smallWidth: 8,
        mediumWidth: 8,
        extraClasses: 'large-3',
        title: t('order_nbr',null,'capital'),
        canSort: true,
        preselected: true,
        sort: {
            direction: sort.direction,
            data_inb_val: sort.sort
        }
    },{
        name: t('user',null,'capital'),
        mediumWidth: 8,
        smallWidth: 8,
        extraClasses: 'large-3',
        title: t('user',null,'capital'),
        canSort: false,
    }, {
        name: t('status',null,'capital'),
        smallWidth: 8,
        mediumWidth: 8,
        extraClasses: 'large-2',
        title: t('status',null,'capital'),
        canSort: false,
    },{
        name: t('price',null,'capital'),
        smallWidth: 8,
        mediumWidth: 8,
        extraClasses: 'large-2',
        title: t('price',null,'capital'),
        canSort: false,
    }
    ];

    return (
        <>
            {!checkout && <OrdersSidebar
                dispatch={props.dispatch}
                heading={t('orders',null,'capital')}
                filter={filter}
                setMainFilter={setFilter}
                filterChangedHandle={filterChangedHandle}
                resetFilter={resetFilter}
                setResetFilter={setResetFilter}
                summary={summary}
                summaryPending={summaryPending}
                language={language}
                showNotification={showNotification}
            />}
            <div id='inb-c-main' className='columns order'>
                <InboomaSubmenu
                    tabs={submenuItems}
                    searchbar={true}
                    extraClasses={"sticky-top"}
                    searchbarPlaceholder={t('order_nbr')}
                    searchbarValue={allUrlParamsClone?.order_nbr !== undefined ? allUrlParamsClone.order_nbr : ""}
                    searchbarHandler={searchBarHandler}
                    smallOnlyTitle={t('orders',null,'capital')}
                    pagination={pagination}
                    itemsCountPerPage={paginationLimit}
                    pageRangeDisplayed={5}
                    onChange={loadNextPage}
                    initialized={initialized}
                    itemLength={orders.length}
                />

                {!checkout && <>
                    <SortNav
                        tabs={tabs}
                        extraClasses={"sticky-top-sortbar"}
                        listStyle="tight"
                        handler={onSortChangedHandle}/>
                </>}
                {/* {initialized && orders.length > 0 && !checkout && !ordersPending && typeof pagination !== 'undefined' &&
                    <Paginator
                        pagination={pagination}
                        itemsCountPerPage={paginationLimit}
                        pageRangeDisplayed={5}
                        onChange={loadNextPage}
                        upper={true}
                    />} */}
                <div className="off-canvas-wrapper">
                    {initialized && orders.length > 0 && !ordersPending && <OrdersList
                        orders={orders}
                        dispatch={props.dispatch}
                        checkout={checkout}
                        filterChangedHandle={filterChangedHandle}
                        filter={filter}
                        setCheckout={setCheckout}
                        _exchangeLabel={_exchangeLabel}
                        setFilter={setFilter}
                        setNKey={setKey}
                        _key={_key}
                        sort={sort}
                        setSort={setSort}
                        locations={locations}
                        openChangeLog={openChangeLog}
                        showNotification={showNotification}
                    />}
                    {!checkout && initialized && orders.length < 1 && !ordersPending &&
                        <>
                            <div
                                id="inb-app-collection-empty"
                                className="inb-announcement"
                                style={{ minHeight: "550px" }}
                            >
                                <div className="inb-image-box">
                                    <img alt="No Data" src={"assets/img/no_data.svg"}/>
                                </div>
                                <h3>
                                    { t('app_msg_collection_empty') }
                                </h3>
                                <p>
                                    { t('app_msg_collection_empty_body') }
                                </p>
                            </div>
                        </>
                    }
                    {/* {initialized && orders.length > 0 && !checkout && !ordersPending && typeof pagination !== 'undefined' &&
                        <Paginator
                            pagination={pagination}
                            itemsCountPerPage={paginationLimit}
                            pageRangeDisplayed={5}
                            onChange={loadNextPage}
                        />} */}

                    {initialized && changelogOpen && !checkout && <ChangeLogDialog
                        changeLogs={changelog}
                        handleCloseDialog={handleCloseDialog}
                        toggleChangeLogs={true}

                    />}
                    {!checkout && ordersPending &&
                        <Loader
                            mediumWidth={2}
                            smallWidth={4}
                            subLoaders={5}/>
                    }
                </div>
            </div>
        </>
    );
};

export default OrdersView;